export default __webpack_public_path__ + "static/media/step-back.126a664f.svg";